/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderXIcon20Solid = forwardRef('FolderXIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h4.3a1.5 1.5 0 0 1 1.205.607l.807 1.09a.75.75 0 0 0 .603.303H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V4.5Zm10.828 5.086a1 1 0 1 0-1.414-1.414L10 9.586 8.586 8.172a1 1 0 0 0-1.414 1.414L8.586 11l-1.414 1.414a1 1 0 1 0 1.414 1.414L10 12.414l1.414 1.414a1 1 0 1 0 1.414-1.414L11.414 11l1.414-1.414Z" })));
});
